var pageData = window.dataLayer[0];

module.exports = {
    handle: (e, product) => {
        if (!product) {
            return;
        }

        let objectProduct = [];
        try{
            objectProduct = JSON.parse(product || []);
        } catch(e) {
            return;
        }

        if (!objectProduct || objectProduct.length === 0) {
            return;
        }

        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

        const productData = {
            event: 'view_item',
            currency: 'CLP',
            items: [{
                item_name: objectProduct[0].name,
                item_brand: objectProduct[0].brand,
                item_category: objectProduct[0].category,
                price: objectProduct[0].price,
                item_id: objectProduct[0].id,
                quantity: 1
            }]
        };

        objectProduct[0].customerId ? productData.userId = objectProduct[0].customerId : null;
        objectProduct[0].emailAddress ? productData.email = objectProduct[0].emailAddress : null;

        dataLayer.push(productData);
    }
}